import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { addRecentHistoryItem } from '../../utils/recentHistory';

class PdpSharedRecentHistoryTracker extends React.Component {
    componentDidMount() {
        const { item } = this.props;
        addRecentHistoryItem(item);
    }

    render() {
        return null;
    }
}

PdpSharedRecentHistoryTracker.propTypes = {
    item: PropTypes.shape({
        serviceId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        firstPhotoWebPath: PropTypes.string.isRequired,
        pdpURL: PropTypes.string.isRequired,
        contemporaryTrackingString: PropTypes.string,
        categoryPath: PropTypes.string.isRequired,
        isComplete: PropTypes.bool.isRequired,
        isListingListed: PropTypes.bool.isRequired,
        seller: PropTypes.shape({
            serviceId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default createFragmentContainer(PdpSharedRecentHistoryTracker, {
    item: graphql`
        fragment PdpSharedRecentHistoryTracker_item on Item {
            serviceId
            title
            firstPhotoWebPath(size: small)
            pdpURL
            contemporaryTrackingString
            categoryPath
            isComplete
            isListingListed
            seller {
                serviceId
            }
        }
    `,
});
